<template lang="pug">
  #nav
    .nav-wrapper
      .lang-bar.desktop
        a(@click="changeLocale('th')")
          img(src="../assets/images/flag-th.svg")
        a(@click="changeLocale('en')")
          img(src="../assets/images/flag-en.svg")
      .logo
      nav
        #navbar
          img(class="menu", src="../assets/images/icon-menu-white.png", @click="toggleMenu", v-show="!menuToggle")
          img(class="menu", src="../assets/images/icon-close-white.png", @click="toggleMenu", v-show="menuToggle")
        //- .language
        //-   a(href="#/en/")
        //-     img(src="../assets/images/flag-en.svg")
        //-   a(@click="changeLocale('en')")
        //-     img(src="../assets/images/flag-bm.svg")
        ul#mobile-nav
          li
            a(:href="'/' + $LOCALE + '/'") #[p {{ $LANG.nav.HOME }}]
          li.dropdown #[p {{ $LANG.nav.COL1_T1 }}]
            ul.dropdown-content
              li
                a(:href="'/' + $LOCALE + '/about/story-of-smaland'") {{ $LANG.nav.COL1_D1 }}
              li
                a(:href="'/' + $LOCALE + '/about/angna-and-anya'") {{ $LANG.nav.COL1_D2 }}
              li
                a(:href="'/' + $LOCALE + '/about/how-to-join'") {{ $LANG.nav.COL1_D3 }}
              li
                a(:href="'/' + $LOCALE + '/benefits-of-smales'") {{ $LANG.nav.COL1_D4 }}
              li
                a(:href="'/' + $LOCALE + '/about/benefits-of-smales'") {{ $LANG.nav.COL1_D5 }}
          li.dropdown #[p {{ $LANG.nav.COL2_T1 }}]
            ul.dropdown-content
              li
                a(:href="'/' + $LOCALE + '/fun-things-at-home/bug-news'") {{ $LANG.nav.COL2_D1 }}
              li
                a(:href="'/' + $LOCALE + '/fun-things-at-home/fun-ideas'") {{ $LANG.nav.COL2_D2 }}
              li
                a(:href="'/' + $LOCALE + '/fun-things-at-home/swedishness'") {{ $LANG.nav.COL2_D3 }}
          li.dropdown #[p {{ $LANG.nav.COL3_T1 }}]
            ul.dropdown-content
              li
                a(:href="'/' + $LOCALE + '/activities-promotions/upcoming-activities'") {{ $LANG.nav.COL3_D1 }}
              li
                a(:href="'/' + $LOCALE + '/activities-promotions/partner-promotions'") {{ $LANG.nav.COL3_D2 }}
              li
                a(:href="'/' + $LOCALE + '/activities-promotions/contest-winners'") {{ $LANG.nav.COL3_D2 }}

          li.dropdown #[p {{ $LANG.nav.COL4_T1 }}]
            ul.dropdown-content
              li
                a(:href="'/' + $LOCALE + '/shroom-store/food-menu'") {{ $LANG.nav.COL4_D1 }}
              li
                a(:href="'/' + $LOCALE + '/shroom-store/merchandise'") {{ $LANG.nav.COL4_D2 }}
              li
                a(:href="'/' + $LOCALE + '/shroom-store/how-to-use-shroom'") {{ $LANG.nav.COL4_D3 }}
              li
                a(:href="'/' + $LOCALE + '/shroom-store/how-to-earn-smallish-dallars'") {{ $LANG.nav.COL4_D4 }}
          li.dropdown.mobile #[p {{ $LANG.nav.LANGUAGE}}]
            ul.dropdown-content
              li
                a.lang(@click="changeLocale('th')")
                  img(src="../assets/images/flag-th.svg")
                  span TH
              li
                a.lang(@click="changeLocale('en')")
                  img(src="../assets/images/flag-en.svg")
                  span EN

</template>
<script>
export default {
  name: 'Nav',
  data () {
    return {
      menuToggle: false,
      lang: 'en'
    }
  },

  mounted () {
    const currentUrl = window.location.href
    if (currentUrl.indexOf('/th') >= 0) {
      this.lang = 'th'
    }
  },

  methods: {
    changeLocale (lang) {
      const currentUrl = window.location.href
      const splittedPath = currentUrl.split('/')
      // staging/production lang config
      // if (splittedPath[5] !== lang) {
      // local lang config
      // if (splittedPath[4] !== lang) {
      if (splittedPath[5] !== lang) {
        const remUrlPos = currentUrl.indexOf('#') + 2
        const remUrl = currentUrl.substr(remUrlPos + 2)
        const startUrl = currentUrl.substr(0, remUrlPos)
        console.log(startUrl)
        console.log(lang)
        console.log(remUrl)
        window.location = startUrl + lang + remUrl
        location.reload()
      }
    },

    redirect (url) {
      const currUrl = window.location.href.split('/')
      let baseURL = currUrl[2]
      const newLoc = 'https://' + baseURL + '/' + this.lang + '/' + url
      window.location = newLoc
    },

    toggleMenu () {
      if (this.menuToggle === false) {
        document.getElementById('mobile-nav').classList.add('active-m')
        this.menuToggle = true
      } else {
        document.getElementById('mobile-nav').classList.remove('active-m')
        this.menuToggle = false
      }
    }
  }
  // router,
  // scrollBehavior (to, from, savedPosition) {
  //   return { x: 0, y: 0 }
  // }
}
</script>
<style lang="sass" scoped>
@import "../sass/variables"

#nav
  display: flex
  flex-flow: row nowrap
  justify-content: center
  align-items: center
  flex-direction: column
  // font-family: "kids-comic"
  font-size: 12px
  margin: auto
  +clearfix

  @media #{$mobile}
    display: initial

  .nav-wrapper
    display: flex
    align-items: center
    position: relative
    margin-top: 20px
    .lang-bar
      display: flex
      width: 100%
      justify-content: flex-end
      position: absolute
      right: 0
      top: -10px
      a
        position: relative
        margin-left: 10px
        cursor: pointer

  .logo
    background-image: url("../assets/images/smales-logo.png")
    background-size: contain
    background-position: center
    background-repeat: no-repeat
    height: 83px
    width: 81px
    float: left

    @media #{$mobile}
      height: 70px
      position: fixed
      top: 5px
      left: 50%
      transform: translateX(-50%)
      z-index: 2

  nav
    float: left

    .menu
      display: none
      @media #{$mobile}
        display: block
        height: 50px
        width: 50px
        float: right

    @media #{$mobile}
      float: none
      background-color: #77d5ff
      height: 50px
      top: 0
      width: 100%
      position: fixed
      z-index: 1
      left: 50%
      transform: translateX(-50%)

    // .language
    //   +clearfix

    //   > a
    //     float: right
    .active-m
      display: block

    > ul
      background-color: #77d5ff
      border-radius: 10px
      background-image: url("../assets/images/header-nav-bg.png")
      +clearlist
      +clearfix

      @media #{$mobile}
        display: none
        top: 50px
        position: absolute
        width: 100%
        background-color: #77d5ff
        background-image: none
        border-radius: 0
        z-index: 1
        padding-top: 20px

      .dropdown
        position: relative
        +mobile
          border-top: 1px solid
        &::after
          +mobile
            content: ''
            background-image: url('../assets/images/btn-plus.svg')
            background-size: 100% 100%
            background-repeat: no-repeat
            background-position: center center
            height: 15px
            width: 15px
            position: absolute
            right: 25px
            top: 50%
            transform: translateY(-50%)
        &:hover
          .dropdown-content
            display: block

      .dropdown-content
        list-style-type: none
        display: none
        position: absolute
        width: 200px
        background-color: #e2f4fd
        padding: 10px
        border: 4px solid white
        border-top: 0
        color: #768eaf
        top: 100%
        left: -15px
        z-index: 10
        @media #{$mobile}
          display: none
          position: relative
          padding: 0
          margin-top: 0
          border: 0
          width: 100%
          left: 0

        a
          display: block
          padding: 10px 0 10px 25px
          color: #778fb0
          &.lang
            display: flex
            align-items: center
            span
              margin-left: 10px
          &:hover
            &::after
              content: ""
              display: block
              position: absolute
              left: 9%
              top: 0%
              transform: translate(-50%)
              width: 30px
              height: 30px
              background-image: url("../assets/images/lady-bug.png")
              background-size: contain
              background-repeat: no-repeat
              background-position: center
              @media #{$mobile}
                left: 2.5%

      .active
        color: #335797
        a
          color: #335797
        &::after
          content: ""
          display: block
          position: absolute
          top: -7px
          left: 50%
          width: 43px
          transform: translateX(-50%)
          background-image: url("../assets/images/lady-bug.png")
          height: 22px
          background-size: contain
          background-repeat: no-repeat
          background-position: center

          @media #{$mobile}
            left: 0
            transform: none

      > li + li
        +desktop
          margin-left: 5px
          border-left: 2px dotted #a7e3fe

      > li
        position: relative
        float: left
        // padding: 16px 15px 10px 15px
        cursor: pointer
        color: white
        p
          margin: 0
          padding: 15px

        a
          text-decoration: none
          color: white
          &:hover
            position: relative
            color: #335797

        @media #{$mobile}
          display: block
          float: none

        &:hover
          color: #335797
          +mobile
            color: #fff

          > a
            color: #335797

          +mobile
            p
              display: flex
              align-items: center
              &::after
                content: ""
                display: inline-block
                transform: translateY(0px)
                width: 43px
                background-image: url(../assets/images/lady-bug.png)
                height: 22px
                background-size: contain
                background-repeat: no-repeat
                background-position: center

          +desktop
            &::after
              content: ""
              display: block
              position: absolute
              top: -7px
              left: 50%
              width: 43px
              transform: translateX(-50%)
              background-image: url("../assets/images/lady-bug.png")
              height: 22px
              background-size: contain
              background-repeat: no-repeat
              background-position: center

              @media #{$mobile}
                left: 0
                transform: none

</style>
